import events from 'lib/events';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import {Header} from 'components/layout';
import {countries, userLevels} from 'helpers/constants';
import PoolVolume from './PoolVolume';
import SeasonsUsage from './SeasonsUsage';
import SystemConversion from './SystemConversion';
import OptimizerPlus from './OptimizerPlus';
import IntlWrapper from 'components/layout/intlWrapper';
import {injectIntl, intlShape} from 'react-intl';
import DealerApi from 'api/dealer';

let render = (container, params) => {
  console.info('[UI.page.tools] rendering page');

  ReactDOM.render(
    <IntlWrapper>
      <QuickCalcsInner subPageName={params.subPage} first={params.first} second={params.second} />
    </IntlWrapper>,
    container);
  events.publish('page-change', {page: 'tools/quick-calcs'});
};

router.rr.add([{path: 'tools/quick-calcs/:subPage', handler: routeUtils.requireAuth(render)}]);

// Page object
class _QuickCalcsInner extends React.Component {
  static defaultProps = {
    subPageName: 'pool-volume',
  };

  static propTypes = {
    subPageName: PropTypes.string,
    subSubPageName: PropTypes.string,
    intl: intlShape,
  };

  state = {
    dealer: {},
  };

  componentWillMount() {
    DealerApi.getDealer(session.getUser().dealerId)
      .then(dealer => {
        this.setState({dealer});
      });
  }

  render() {
    let {subPageName} = this.props;
    const {formatMessage} = this.props.intl;

    let subPages = {
      'seasons-usage': {name: formatMessage({id: 'quick-calcs.seasons-usage.title'}), element: <SeasonsUsage />, permissionLevel: userLevels.testStation},
      'pool-volume': {name: formatMessage({id: 'quick-calcs.pool-volume.title'}), element: <PoolVolume />, permissionLevel: userLevels.testStation},
      'optimizer-plus': {name: formatMessage({id: 'quick-calcs.optimizer-plus.title'}), element: <OptimizerPlus />, permissionLevel: userLevels.testStation},
    };

    if (this.state.dealer.country !== countries.CA) {
      subPages['system-conversion'] = {
        name: formatMessage({id: 'quick-calcs.system-conversion.title'}),
        element: <SystemConversion />,
        permissionLevel: userLevels.testStation,
      };
    }

    let subPagesTabs = Object.keys(subPages)
      .filter(sp => subPages[sp].permissionLevel <= session.getUser().privileges.level)
      .map(sp => <a key={sp} className={subPageName === sp ? 'active' : ''}
                    href={'#tools/quick-calcs/' + sp}>{subPages[sp].name}
      </a>);
    let subPage = '';

    if (subPages[subPageName].permissionLevel <= session.getUser().privileges.level) {
      subPage = subPages[subPageName].element;
    }

    return (
      <div className='container nav-tabs'>
        <Header mainTitle={formatMessage({id: 'tools.title'})}
                mainTitleReturn='#tools'
                subTitle={formatMessage({id: 'quick-calcs.title'})} />
        <nav className='navigation-tabs'>
          {subPagesTabs}
        </nav>
        {subPage}
      </div>);
  }
}

const QuickCalcsInner = injectIntl(_QuickCalcsInner);

export default QuickCalcsInner;
